var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0084B1",
    d: "M0 0h27v27H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.295 4a2.29 2.29 0 0 1 2.272 2.29C8.564 7.604 7.475 8.595 6.28 8.566 5.066 8.592 4 7.577 4 6.281A2.292 2.292 0 0 1 6.295 4zM7.62 22.997H4.947a.629.629 0 0 1-.628-.629V10.944c0-.348.28-.63.628-.63h2.671c.347 0 .628.282.628.63v11.424c0 .348-.28.63-.628.63zM23 14.327a4.332 4.332 0 0 0-4.326-4.336h-.686a3.838 3.838 0 0 0-3.367 1.992.288.288 0 0 0-.036-.005v-1.402a.261.261 0 0 0-.26-.261H10.99a.261.261 0 0 0-.26.26v12.161a.26.26 0 0 0 .26.261l3.406.001a.26.26 0 0 0 .26-.261v-7.025c0-1.215.967-2.223 2.179-2.237a2.204 2.204 0 0 1 2.229 2.208v7.055c0 .144.116.261.26.261l3.414.001c.144 0 .261-.117.261-.261v-8.412z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlueIcon);
export default __webpack_public_path__ + "static/media/linkedin-blue-icon.0b7133bc321820dfe76da6fa31f50c43.svg";
export { ForwardRef as ReactComponent };